import type { ServiceTopology } from 'types/core';

const { serviceTopology } = window;

export default serviceTopology as ServiceTopology;
